export default {
  meta: {
    'key-content': '免費語音通話，安全通信，即時通信，閱後即焚，安全聊天，加密聊天，Telegram，Sugram，Whatsapp',
    'description-content': 'Crait是一款安全通信和合作工具，旨在提升個人和組織的溝通效率的同時保護數據和資訊安全。通過企業級的資料加密，用戶的隱私將會得到有效保護。',
    'h-m-title': 'Crait | 談任何你想談的'
  },
  head: {
    'home': '首頁',
    'features': '產品',
    'pricing': '定價',
    'resources': '資源',
    'openapi': '開放平臺',
    'contact': '聯系我們',
    'download': '下載',
    'login': '登錄',
    'console': '管理中台',
    'CraitForWeb': 'Crait web版'
  },
  home: {
    'title1': '聊任何你想聊的',
    'title2': '安全即時通信',
    'subtitle': '端到端加密.閱後即焚.免費音視頻電話',
    'placeholder': '您的郵箱，電話或用戶名',
    'getstart': '即刻試用',
    'contitle': 'Crait的優勢',
    'intro1-title': '為多人溝通設計',
    'intro1-detail': '支持創建1000人群組和多人電話會議，所有消息、圖片、視頻均受到端到端加密保護',
    'intro2-title': '為安全通訊設計',
    'intro2-detail': '行業標準的256位AES端到端加密技術，所有通訊均有傳輸層保護（TLS），有效防止中間人攻擊',
    'intro3-title': '為高度可定制化設計',
    'intro4-title': '為提高效率設計',
    'intro4-detail': '安全郵件、加密雲盤保證文件的安全。日曆設置待辦事項，提高工作效率',
    'intro3-detail': '組織管理者可以在Crait中創建組織架構，同時通過權限控制，來自定義組織中的數據訪問權限',
    'keyfeature-title': '核心功能',
    'keyfeature-list1': '安全聊天',
    'keyfeature-list2': '安全語音',
    'keyfeature-list3': '安全文件傳輸',
    'keyfeature-list4': '支持多平臺',
    'keyfeature-list5': '語音消息',
    'keyfeature-list6': '安全雲盤',
    'learnmore': '了解更多',
    'download-title': '支持各大平臺',
    'download-detail': 'Crait是壹款為安全團隊溝通和協作而設計的加密通信軟件，支持跨平臺間同步用戶數據，旨在提升工作效率和安全性',
    'err-tip-email': '抱歉，郵箱不正確',
    'err-tip-phone': '抱歉，手機號碼不正確',
    'click': '點擊',
    'wx-tip1': '右上角的按鈕',
    'select': '選擇',
    'wx-tip2': '在瀏覽器打開'
  },
  features: {
    'f-title': '安全的加密通訊，沒有人知道你和你朋友的聊天內容',
    'feature-title': '安全即時通信',
    'feature-list1-title': '安全聊天',
    'feature-list1-detail': '支持點對點聊天和最大1000人的群聊',
    'feature-list2-title': '安全語音',
    'feature-list2-detail': '支持點對點語音呼叫和最多20人的電話會議',
    'feature-list3-title': '電話會議',
    'feature-list3-detail': '支持端到端加密的電話會議，自帶“語音聚焦”功能，自動增加發言人音量的同時過濾環境噪音',
    'feature-list4-title': '跨平臺同步',
    'feature-list4-detail': '支持各大主流平臺',
    'feature-list5-title': '語音消息',
    'feature-list5-detail': '支持發送語音消息',
    'feature-list6-title': '安全文件分享',
    'feature-list6-detail': '支持在群組中安全分享最大100MB的文件',
    'feature-list7-title': '安全雲盤',
    'feature-list7-detail': '支持最大1GB的加密個人雲盤',
    'feature-list8-title': '群發消息',
    'feature-list8-detail': '支持向個人好友或組織成員群發消息',
    'feature-list9-title': '安全性',
    'feature-list9-detail': '集成閱後即焚、消息防截屏、消息閱讀回執功能',
    'other-feature': '其他功能',
    'other-list1-title': '可定制插件',
    'other-list1-detail': '客戶可根據行業或組織的特定需求定制插件，例如日歷分享、會議室預定、辦公室物資管理等',
    'other-list2-title': '搜索',
    'other-list2-detail': '支持跨聊天搜索歷史消息、組織內跨部門搜索成員'
  },
  pricing: {
    'p-title1': '功能',
    'p-title2': 'Crait',
    'p-title3': 'Crait Pro',
    'unlimited': '無限',
    'tr1-td1': '群組數量限制',
    'tr2-td1': '群成員人數限制',
    'tr3-td1': '廣播消息人數限制',
    'tr4-td1': '電話會議人數限制',
    'tr5-td1': '群空間容量',
    'tr6-td1': '個人雲盤容量',
    'tr7-td1': '視頻電話',
    'tr8-td1': '定制插件',
    'tr8-td2': '不支持',
    'tr8-td3': '按單個插件計費',
    'tr9-td1': '客戶服務和技術支持',
    'tr9-td2': 'APP內技術支持',
    'tr9-td3': '7x24小時 (郵件或電話)',
    'tr10-td1': '提供團隊管理平臺',
    'tr11-td1': '全平臺支持',
    'tr12-td1': '價格',
    'tr12-td2': '免費',
    'tr12-td3': '2.99美元每月',
    'btn1': '即刻試用',
    'btn2': '現在升級'
  },
  resources: {
    'readmore1': '閱讀更多 ->',
    'readmore2': '閱讀更多',
    'r-title1': '白皮書',
    'r-title2': '博客',
    'subtitle1': 'WHAT IS CRAIT?',
    'detail1': 'Crait is where secure communication and collaboration happens. It is a secure messaging tool designed to make working life easier and more productive for work-groups...',
    'subtitle2': 'Data Breach Trends',
    'detail2': 'Data breaches are no good. It will serve companies well to reexamine their basic security hygiene with a deliberate view of strengthening their respective security postures...',
    'subtitle3': 'Small Enterprises Are Easy Targets',
    'detail3': 'Not all commonsensical ideas hold water. One example of a commonplace idea that does not match reality is the notion that hackers only target big businesses. The rising number of cyber attacks on small businesses strongly contradicts this seemingly prevalent sentiment that small businesses aren’t the target of hacks. Let’s examine the facts...'
  },
  contact: {
    'c-title1': '歡迎您與我們進壹步溝通了解更多關於Crait的信息',
    'c-title2': '請提供更多關於您組織的信息，我們的銷售人員會很快與您取得聯系',
    'firstname': '姓氏 *',
    'lastname': '名字 *',
    'workemail': '工作郵箱 *',
    'phone': '電話號碼 *',
    'company': '組織名稱 *',
    'size': '組織規模 *',
    'location': '地點',
    'industry': '行業',
    'send': '發送',
    'emaillabel': '郵箱: ',
    'email': 'info@craitapp.com'
  },
  download: {
    'intro': 'Crait是壹款為安全團隊溝通和協作而設計的加密通信軟件，支持跨平臺間同步用戶數據，旨在提升工作效率和安全性',
    'd-title': '應用支持各大平臺',
    'sub-intro1': '您可以掃碼或者點擊下方按鈕下載Crait.',
    'sub-intro2': '或者即刻開始使用Crait Web版',
    'home-download-title1': '協作新方式',
    'home-download-title2': '免费IM',
    'home-download-title3': '郵件',
    'home-download-title4': '電話會議',
    'home-download-title5': '前往Crait Web版',
    'home-download-title6': '下載Crait PC版',
    'home-download-title7': '即刻試用',
    'home-download-title8': '雲盤',
    'download-getApp': '獲取應用程序 ',
    'download-iphone': 'iPhone',
    'download-scanCode': '掃碼',
    'download-dlApp': '下載App',
    'download-gphone': 'Android',
    'download-pc': 'PC',
    'download-chrome': 'Chrome',
    'download-title-m': '協作新方式',
    'download-dl-btn': '即刻試用'
  },
  payment: {
    'prices-payment-title1': '購買帳號',
    'prices-payment-title2': '請輸入需要購買Crait Pro的帳號',
    'prices-payment-title3': '請選擇您希望購買的方案',
    'prices-payment-title4': '請選擇',
    'prices-payment-title5': '合計',
    'prices-payment-title6': '支付方式',
    'prices-payment-title7': 'PayPal',
    'prices-payment-title8': '立即支付',
    'prices-payment-title9': '開通Crait Pro即表示您同意以下協定',
    'prices-payment-title10': 'Crait付費會員協定',
    'prices-payment-title11': '隱私政策',
    'prices-payment-title12': '網絡錯誤！',
    'prices-payment-title13': '請輸入已注册的Crait帳號'
  },
  confirm: {
    'prices-confirm-title1': '購買帳號',
    'prices-confirm-title2': '已選擇的方案',
    'prices-confirm-title3': '合計',
    'prices-confirm-title4': '支付方式',
    'prices-confirm-title5': '前往支付',
    'prices-confirm-title6': '正在前往協力廠商支付頁面…',
    'prices-confirm-title7': '請在打開的協力廠商支付頁面中完成支付',
    'prices-confirm-title8': '未完成支付',
    'prices-confirm-title9': '已完成支付',
    'prices-confirm-title10': '網絡錯誤！'
  },
  success: {
    'prices-success-title1': '您的Crait Pro許可權已購買完成',
    'prices-success-title2': '待支付資訊確認後，重新登入帳號後即可享有Crait Pro權益',
    'prices-success-title3': '購買帳號',
    'prices-success-title4': '已購買的方案'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/td.js